import {useEffect, useState} from "react";
import {
    Button,
    CalendarBlue,
    DocBlack,
    InfoOrange,
    LoadingGreen,
    Tag,
    Toggle,
    WarningRed
} from "omoplay";
import {getProjectList, turnProject} from "../../api/project/project.api";
import GenericBoard from "../form/GenericBoard";

const ProjectList = () => {
    const [projectData, setProjectData] = useState([])
    const [projectTableData, setProjectTableData] = useState([])

    useEffect(() => {
        getProjectList().then(({data}) => {
            setProjectData(data)
        })
    }, []);

    const onToggleTurn = (id, flag) => {
        setProjectData(prevData =>
            prevData.map(project =>
                project.id === id ? { ...project, start: flag } : project
            )
        )
        setTimeout(() => {
            const message = flag ? "해당 프로젝트를 시작 하시겠습니까?\n시작기간 수정 및 이벤트 수정이 불가능해 집니다." : "해당 프로젝트를 종료 하시겠습니까?"
            if (window.confirm(message)) {
                turnProject(id, flag).then(({data}) => {
                    if (data) {
                        alert(data)
                    }
                    window.location.reload()
                })
            } else {
                setProjectData(prevData =>
                    prevData.map(project =>
                        project.id === id ? { ...project, start: !flag } : project
                    )
                )
            }
        }, 0)
    }

    useEffect(() => {
        setProjectTableData(
            projectData.map(project => {
                let icon = <DocBlack />

                if (project.status === "PROGRESS") {
                    icon = <LoadingGreen />
                } else if (project.status === "PREPARE") {
                    icon = <InfoOrange />
                } else if (project.status === "NECESSARY") {
                    icon = <WarningRed />
                } else if (project.status === "RESERVED") {
                    icon = <CalendarBlue />
                }
                return [
                    <div className="flex-center-all h-full">
                        <Toggle value={project.start}
                                disabled={project.status === "NECESSARY"}
                                onToggle={(flag) => onToggleTurn(project.id, flag)} />
                    </div>,
                    <div className="flex-align-center gap-2 h-full text-primary pointer"
                         onClick={() => window.location.href = (`/project/detail?id=${project.id}`)}>
                        <div>{icon}</div>
                        <div>{project.name}</div>
                    </div>,
                    <div className="flex-align-center gap-2 h-full">
                        <div className="flex gap-2">
                            <div><Tag>{project.startDate}</Tag></div>
                        </div>
                        ~
                        <div className="flex gap-2">
                            <div><Tag>{project.endDate ?? "상시 진행"}</Tag></div>
                        </div>
                    </div>,
                    <div className="flex-align-center gap-2 h-full">
                        {
                            project.badgeColor === "blue" && (<div className="text-primary font-bold">D-{project.days}</div>)
                        }
                        <Tag size="small" color={project.badgeColor}>{project.statusKor}</Tag>
                    </div>,
                ]
            })
        )
    }, [projectData]);

    return (
        <>
            <div className="flex justify-between items-end mb-4">
                <div>
                    총 <span className="text-primary font-bold">{projectTableData.length}</span>개
                </div>
                <Button variants="primary" value="+ 프로젝트 추가" onClick={() => {window.location.href = ("/project/edit")}} />
            </div>
            <div>
                <GenericBoard items={projectTableData} columns={[
                    { align: 'center', width: 'w-20' },  // 1: 토글 버튼 (가운데 정렬)
                    { align: 'left', flex: true },       // 2: 제목 (왼쪽 정렬, 남는 공간 모두 차지)
                    { align: 'center' },                 // 3: 날짜 (가운데 정렬)
                    { align: 'right', width: 'w-32' }    // 4: 상태 배지 (오른쪽 정렬)
                ]} />
            </div>
        </>
    );
};

export default ProjectList;
